import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { MemoType } from '@kinderlabs-pos/shared-data-type';

export const createMemoAsync =
	(rootUrl: string) =>
	async ({ memoBody }: { memoBody: Omit<MemoType, 'id'> }) =>
		(await posAxiosClient.post(`${rootUrl}/memo`, memoBody)).data;
